import { formatStringInNav } from '../../../Helpers/String+Extension'

export const renderBreadcrumbs = songData =>
  songData
    ? [
        {
          title: 'All Artists',
          link: `/artists`,
        },
        {
          title: songData.song_artist_name,
          link: `/artist/${formatStringInNav(songData.artist.artist_name)}`,
        },
        {
          title: 'Teases',
          link: `/teases/artist/${formatStringInNav(
            songData.artist.artist_name
          )}`,
        },
        {
          title: songData.name,
          link: `/tease/${songData.f_id}`,
        },
        {
          title: 'Edit Timing',
          link: `/edit-tease/${songData.f_id}`,
        },
      ]
    : [
        [
          {
            title: 'All Songs',
            link: '/songs/all',
          },
        ],
      ]
